import * as React from "react";
import { cn } from "./utils";

/**
 * GlassyCard — 디자인 시스템 universal card 패턴.
 *
 * 어두운 배경 위 반투명 글래시 표면. hover 시 카드 자체는 움직이지 않고
 * 배경·테두리만 미세하게 밝아진다. 내부 이미지에는 `group-hover:scale-105`
 * 같은 효과를 적용할 수 있도록 항상 `group` 클래스를 포함한다.
 */
const radiusMap = {
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  "2xl": "rounded-2xl",
} as const;

type GlassyCardProps = {
  children?: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  radius?: keyof typeof radiusMap;
} & React.HTMLAttributes<HTMLDivElement>;

const GlassyCard = React.forwardRef<HTMLDivElement, GlassyCardProps>(
  (
    { children, className, hoverable = true, radius = "2xl", ...props },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        data-slot="glassy-card"
        className={cn(
          "group bg-white/[0.03] border border-white/[0.06] transition-all duration-500 ease-[cubic-bezier(0.2,0.8,0.2,1)]",
          radiusMap[radius],
          hoverable && "hover:bg-white/[0.04] hover:border-white/20",
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);
GlassyCard.displayName = "GlassyCard";

export { GlassyCard };
export type { GlassyCardProps };
